/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiCaseRationale,
    InternalApiCaseRationaleFromJSON,
    InternalApiCaseRationaleToJSON,
} from '../models';

/**
 * 
 */
export class CaseRationaleInternalApi extends runtime.BaseAPI {

    /**
     * Fetches all case rationales for the organisation
     */
    async findAllCaseRationalesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiCaseRationale>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases/rationales`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiCaseRationaleFromJSON));
    }

    /**
     * Fetches all case rationales for the organisation
     */
    async findAllCaseRationales(initOverrides?: RequestInit): Promise<Array<InternalApiCaseRationale>> {
        const response = await this.findAllCaseRationalesRaw(initOverrides);
        return await response.value();
    }

}
